import { AuthorizationPaymentListItem } from 'pages/AuthorizePaymentPage/types';
import { Invoice, VendorPaymentDetails } from './types';

export const processRetryData = (
  vendorPaymentDetails: VendorPaymentDetails[]
): AuthorizationPaymentListItem[] =>
  vendorPaymentDetails
    ?.map((vendorPaymentDetail: VendorPaymentDetails) =>
      vendorPaymentDetail?.listOfInvoices.map((invoice: Invoice) => ({
        vendorNo: vendorPaymentDetail.vendorNo,
        vendorName: vendorPaymentDetail.vendorName,
        invoiceId: invoice.invoiceId,
        amount: invoice.amount,
        invoiceDescription: invoice?.invoiceDescription ?? '',
        invoiceDate: invoice.invoiceDate,
        dueDate: invoice.dueDate,
        discountAmount: invoice.discountAmount,
        netAmount: invoice.netAmount
      }))
    )
    .flat();
